import React, { useState } from 'react';
import styles from './Nav.module.sass';
import logo from '../../assets/logo.jpg';
import Image from '../Image';
import Menu from './Menu';
import NavCart from './NavCart';
import { Link } from 'react-router-dom';

const Nav = () => {
  const [open, setOpen] = useState(false)

  return (
    <nav className={styles.nav}>
      <Menu />
      <Link to='/'>
        <Image src={logo} classes={styles.logo} />
      </Link>
      <NavCart />
    </nav>
  );
};

export default Nav;
